import { check } from "./check.js";
export default function parseCheckDigit(checkDigit, value) {
    check(value, checkDigit);
    return checkDigit;
}
//# sourceMappingURL=parseDateCheckDigit.js.map